/**
 * Utilitário para aplicar máscaras.
 * 0 = dígito obrigatório, demais caracteres = literais.
 * Suporta máscara condicional: "pattern1||pattern2" (ex: CPF até 11 dígitos, CNPJ a partir de 12).
 */

export function applyMask(value: string | null | undefined, pattern: string): string {
  if (value == null) return '';
  let digits = (value + '').replace(/\D/g, '');
  if (digits.length === 0) return '';

  const effectivePattern = resolveConditionalPattern(pattern, digits.length);
  const maxDigits = (effectivePattern.match(/0/g) || []).length;
  digits = digits.slice(0, maxDigits);

  let out = '';
  let d = 0;
  for (let i = 0; i < effectivePattern.length && d < digits.length; i++) {
    if (effectivePattern[i] === '0') {
      out += digits[d++];
    } else {
      out += effectivePattern[i];
    }
  }
  return out;
}

/**
 * Para máscara condicional "000.000.000-00||00.000.000/0000-00", escolhe o padrão pelo número de dígitos.
 */
function resolveConditionalPattern(pattern: string, digitCount: number): string {
  const parts = pattern.split('||');
  if (parts.length <= 1) return pattern.trim();
  // CPF = 11 dígitos, CNPJ = 14
  const useFirst = digitCount <= 11;
  return (useFirst ? parts[0] : parts[1]).trim();
}

/**
 * Retorna apenas os dígitos do valor já mascarado (para salvar no form/backend).
 */
export function getUnmaskedValue(value: string | null | undefined): string {
  if (value == null) return '';
  return (value + '').replace(/\D/g, '');
}
